import React from "react";
import Message from "../Message/Message";
import ScrollToBottom from "react-scroll-to-bottom";



const Messages = ({ messages, name, typing }) => {
  return (
    <ScrollToBottom className="overflow-auto h-5/6" >
      {messages.map((message, index) => (
        <Message key={index} message={message} name={name} />
      ))}
      <div className="mx-3 mb-10 text-sm font-semibold text-gray-400">
        {typing ?'someone is typing ...':''}
      </div>
    </ScrollToBottom>
  );
};

export default Messages;
